import { render, staticRenderFns } from "./RealEstateMarketAnalysisList.vue?vue&type=template&id=71ed0f82&scoped=true&"
import script from "./RealEstateMarketAnalysisList.vue?vue&type=script&lang=js&"
export * from "./RealEstateMarketAnalysisList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed0f82",
  null
  
)

export default component.exports